__turbopack_context__.v({
  "boxContainer": "styles-module-scss-module__aKz7eq__boxContainer",
  "carouselContainer": "styles-module-scss-module__aKz7eq__carouselContainer",
  "labelContainer": "styles-module-scss-module__aKz7eq__labelContainer",
});
